import { getName } from 'country-list'

export const btnStyle = {
  mounted() {
    switch (this.$attrs.size) {
      case 'sm':
        this.size = 'px-3 py-1 h-8'
        this.font = 'text-sm'
        break
      case 'lg':
        this.size = 'px-5 py-3 h-12'
        this.font = 'text-lg'
        break
      default:
        this.size = 'px-4 py-2 h-10 lg:min-w-40'
        this.font = 'text-base'
    }
  },
  data() {
    return {
      size: '',
      font: '',
    }
  },
}

export const inputStyle = {
  mounted() {
    switch (this.$attrs.size) {
      case 'sm':
        this.labelFont = 'text-xs font-semibold text-gray-800'
        this.size = 'text-sm px-2 py-1 h-8'
        this.cl = 'pb-1 lg:pb-2'
        break
      case 'lg':
        this.labelFont = 'text-lg font-semibold text-gray-800'
        this.size = 'text-lg px-3 py-2 h-12'
        this.cl = 'pb-4 lg:pb-5'
        break
      default:
        this.labelFont = 'text-base font-semibold text-gray-800'
        this.size = 'text-base px-2 py-2 h-10'
        this.cl = 'pb-2 lg:pb-3'
    }
    if (typeof this.$attrs.condensed !== 'undefined') {
      this.cl = ''
    }
  },
  data() {
    return {
      labelFont: '',
      size: '',
      cl: '',
    }
  },
}

export const labelStyle = {
  mounted() {
    switch (this.$attrs.size) {
      case 'sm':
        this.font = 'text-xs font-semibold text-gray-800'
        break
      case 'lg':
        this.font = 'text-lg font-semibold text-gray-800'
        break
      default:
        this.font = 'text-base font-semibold text-gray-800'
    }
  },
  data() {
    return {
      font: '',
    }
  },
}

export const iconStyle = {
  mounted() {
    switch (this.$attrs.size) {
      case 'xs':
        this.size = 'px-2 py-1'
        this.font = 'text-xs'
        break
      case 'sm':
        this.size = 'px-2 py-2'
        this.font = 'text-sm'
        break
      case 'lg':
        this.size = 'px-3 py-3'
        this.font = 'text-xl'
        break
      default:
        this.size = 'px-2 py-2'
        this.font = 'text-base'
    }
  },
  data() {
    return {
      size: '',
      font: '',
    }
  },
}

export const selectStyle = {
  mounted() {
    switch (this.$attrs.size) {
      case 'xs':
        this.size = 'px-2 py-1'
        this.font = 'mb-1 block text-xs font-semibold text-gray-800'
        break
      case 'sm':
        this.size = 'px-2 py-2'
        this.font = 'mb-1 block text-sm font-semibold text-gray-800'
        break
      case 'lg':
        this.size = 'px-3 py-3'
        this.font = 'mb-1 block text-lg font-semibold text-gray-800'
        break
      default:
        this.size = 'px-2 py-2'
        this.font = 'mb-1 block text-base font-semibold text-gray-800'
    }
  },
  data() {
    return {
      size: '',
      font: '',
    }
  },
}

export const cardStyle = {
  mounted() {
    switch (this.$attrs.size) {
      case 'sm':
        this.spacing = 'py-2 px-4'
        this.size = 'w-full '
        this.fontTitle = 'text-lg'
        break
      case 'lg':
        this.spacing = 'py-4 px-6'
        this.size = 'w-full '
        this.fontTitle = 'text-2xl'
        break
      default:
        this.spacing = 'py-3 px-5'
        this.size = 'w-full '
        this.fontTitle = 'text-xl'
    }
    if (this.$attrs.dark) {
      this.bg = 'bg-secondary-light'
    }
  },
  data() {
    return {
      size: '',
      spacing: '',
      fontTitle: '',
      bg: 'bg-white',
    }
  },
}

export const alertStyle = {
  mounted() {
    switch (this.$attrs.size) {
      case 'sm':
        this.fontIcon = 'text-xl'
        this.size = 'px-3 py-2 mb-4'
        this.font = 'text-sm'
        break
      default:
        break
    }
  },
  data() {
    return {
      fontIcon: 'text-2xl',
      size: 'px-3 py-2 mb-6',
      font: 'text-base',
    }
  },
}

export const errorHandler = {
  data() {
    return {
      errors: {},
    }
  },
  methods: {
    setError(error) {
      const detail = error.detail ? error.detail : error
      this.errors = { detail, type: 'inline' }
    },
  },
  components: {
    FormError: () => import('@/components/shared/FormError.vue'),
  },
}

export const serviceWorkerUpdate = {
  data() {
    return {
      serviceWorkerRegistration: null,
      serviceWorkerUpdated: false,
    }
  },

  created() {
    document.addEventListener('serviceWorkerUpdated', this.onServiceWorkerUpdated, { once: true })
    navigator.serviceWorker.addEventListener('controllerchange', () => { window.location.reload() })

  },

  methods: {

    onServiceWorkerUpdated(event) {
      console.log(event)
      this.serviceWorkerRegistration = event.detail
      this.serviceWorkerUpdated = true
    },

    onAppReload() {
      this.serviceWorkerUpdated = false
      console.log(this.serviceWorkerRegistration)
      if (!this.serviceWorkerRegistration || !this.serviceWorkerRegistration.waiting) { return }
      this.serviceWorkerRegistration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }

  }
}

export const getCountryName = {
  methods: {
    getCountryName(code) {
      return code ? getName(code) : ''

    }
  }
}